module.exports = __webpack_public_path__ + "static/media/RESEARCH_c09_20150828.5185dd57.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/RESEARCH_c09_20150828.png
// module id = 152
// module chunks = 0